/*
 * Página de Favoritos — Ariel Malhas
 * Lê os IDs salvos em localStorage (mesma chave usada pelos corações dos
 * cards) e busca os produtos via Section Rendering API, reaproveitando o
 * padrão de "recently viewed" do tema (/search?q=id:1 OR id:2).
 */
(function () {
  'use strict';

  var KEY = 'ariel_wishlist';

  function getIds() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]').map(String).filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function setIds(ids) {
    try {
      localStorage.setItem(KEY, JSON.stringify(ids));
    } catch (e) {
      /* armazenamento indisponível */
    }
  }

  function init() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;

    var grid = root.querySelector('[data-wish-grid]');
    var empty = root.querySelector('[data-wish-empty]');
    var loading = root.querySelector('[data-wish-loading]');
    var countEl = root.querySelector('[data-wish-count]');
    var clearBtn = root.querySelector('[data-wish-clear]');

    function showEmpty() {
      if (loading) loading.hidden = true;
      if (grid) grid.hidden = true;
      if (empty) empty.hidden = false;
      if (countEl) countEl.hidden = true;
      if (clearBtn) clearBtn.hidden = true;
    }

    function updateCount() {
      var n = grid ? grid.querySelectorAll('[data-wish-item]').length : 0;
      if (n === 0) {
        showEmpty();
        return;
      }
      if (countEl) {
        countEl.textContent = n + (n === 1 ? ' item' : ' itens');
        countEl.hidden = false;
      }
      if (clearBtn) clearBtn.hidden = false;
    }

    var ids = getIds();
    if (ids.length === 0) {
      showEmpty();
      return;
    }

    // Monta a busca por IDs e pede só a seção de resultados.
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var sectionId = root.getAttribute('data-results-section');
    var url = new URL(searchUrl, window.location.origin);
    url.searchParams.set(
      'q',
      ids
        .map(function (id) {
          return 'id:' + id;
        })
        .join(' OR ')
    );
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString())
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var products = parsed.getElementById('ariel-wishlist-products');
        if (!products || products.children.length === 0) {
          showEmpty();
          return;
        }
        if (loading) loading.hidden = true;
        if (grid) {
          grid.innerHTML = '';
          grid.appendChild(products);
          grid.hidden = false;
        }
        updateCount();
      })
      .catch(function () {
        if (loading) loading.textContent = 'Não foi possível carregar seus favoritos agora.';
      });

    /*
     * O coração do card já remove o produto do localStorage (wishlist.js).
     * Aqui apenas removemos o item da tela para o resultado refletir a ação
     * na hora, sem exigir recarregar a página.
     */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var heart = e.target.closest('[data-ariel-wishlist]');
      if (!heart || !grid || grid.hidden) return;

      var item = heart.closest('[data-wish-item]');
      if (!item) return;

      // Após o wishlist.js processar o clique, checa se saiu dos favoritos.
      window.setTimeout(function () {
        if (heart.getAttribute('aria-pressed') !== 'true') {
          item.remove();
          updateCount();
        }
      }, 0);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        setIds([]);
        if (grid) grid.innerHTML = '';
        showEmpty();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
